const config = {
  // AWS Region
  region: 'us-west-2',
  
  // Cognito Configuration
  cognito: {
    userPoolId: 'us-west-2_TDy08Rgrl',
    userPoolWebClientId: '13mi4qff1i6chalta75tcllvc8',
    identityPoolId: 'us-west-2:6e7d6b88-254a-4ecb-bcce-7dc4f1951b4d',
    region: 'us-west-2'
  },
  
  // Main API Configuration
  api: {
    endpoint: 'https://api.agentdeveloper.agent-enterprise.com',
    region: 'us-west-2',
    name: 'api'
  },
  
  // Conversation API Configuration
  conversationApi: {
    dev: {
      endpoint: 'https://conversation-dev.agentdeveloper.agent-enterprise.com',
      region: 'us-west-2'
    },
    prod: {
      endpoint: 'https://conversation.agentdeveloper.agent-enterprise.com',
      region: 'us-west-2'
    }
  },
  
  // AWS Defaults
  aws: {
    defaultAccount: '606639293792',
    defaultRegion: 'us-west-2',
    defaultRole: 'arn:aws:iam::851725399969:role/AgentAWSDeveloperGithub'
  },
  
  // GitHub Defaults
  github: {
    defaultAccount: 'materassi',
    defaultTokenSecretName: 'GitHubToken'
  },
  
  // Agent Defaults
  agent: {
    defaultParentName: 'AgentDeveloper',
    defaultRepoName: 'AgentDeveloper'
  },
  
  // CDK Defaults
  cdk: {
    defaultQualifier: 'agentdev'
  }
};

export default config;
